import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Products from '@/components/products'
import ProductDetail from '@/components/productDetail'
import AboutUs from '@/components/aboutUs'
import ContactUs from '@/components/contactUs.vue'
Vue.use(Router)

export default new Router({
  routes: [
      {
        path: '/',
        name: 'Index',
        component: Index
      },
      {
        path: '/products',
        name: 'Products',
        component: Products
      },
      {
        path: '/productDetail',
        name: 'ProductDetail',
        component: ProductDetail
      },
      {
          path: '/aboutus',
          name: 'AboutUs',
          component: AboutUs
      },
      {
          path: '/contactus',
          name: 'ContactUs',
          component: ContactUs
      }

  ]
})
